<template>
  <div class="content">
    <h3>{{ $t('dialogs.cityInfo') }}</h3>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="cityInfoText"></div>
  </div>

  <div class="actions p-d-flex">
    <tm-button class="p-mr-2" :label="$t('dialogs.close')" type="reversed" @click="closeDialog" />
    <tm-button :label="$t('dialogs.close and remember')" type="confirm" @click="rememberAndCloseDialog" />
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import useDialog from '@composables/useDialog';
import { computed } from 'vue';
import DOMPurify from 'dompurify';

const store = useStore();
const { locale } = useI18n();
const { close: closeDialog } = useDialog();

const cityInfoText = computed(() => {
  const envLangSuffix = locale.value.toUpperCase();
  const envText = import.meta.env[`VITE_TEXT_CITY_INFO_${envLangSuffix}`] || '';
  return DOMPurify.sanitize(envText);
});

const rememberAndCloseDialog = () => {
  store.commit('layout/SET_CITY_INFO', { wasSeen: true });
  closeDialog();
};
</script>

<style scoped>
.content {
  max-width: 25rem;
  font-size: 0.9rem;
}
:deep(.p-button) {
  font-size: 0.9rem;
  font-weight: 500;
}
</style>
